// extracted by mini-css-extract-plugin
export default {"profile_pic":"user-profile_profile_pic__q9jVn","profile_pic_shrink":"user-profile_profile_pic_shrink__BMIPq"};